import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useAtom } from 'jotai';
import React, { useCallback } from 'react';

import { ToolBar } from '~/components/blocks';
import { useMedicationFollowupSettingStatus } from '~/components/partials/PatientDetailDialog/use-medication-followup-setting-status';
import { SelectDateWithMoveButton } from '~/components/partials/SelectDateWithMoveButton';
import { patientPageInfoState } from '~/state/patient/atoms';

import { FollowingUpCheckBox } from './FollowingUpCheckBox';
import { NewPatientButton } from './NewPatientButton';
import { SearchBox } from './SearchBox';
import { SelectPharmacist } from './SelectPharmacist';

const InputDateWrapper = styled('div')(() =>
  css({
    alignItems: 'center',
  }),
);

const ToolBarItem = styled(ToolBar.Item)(({ theme }) =>
  css({
    alignItems: 'center',
    display: 'flex',
    borderRight: `1px ${theme.colors.colorPallete.grey03} solid`,
    fontWeight: theme.fontWeights.bold,
    height: '35px',
    [`@media ${theme.mediaQueries.tablet}`]: {
      fontSize: theme.fontSizes.s,
      height: '25px',
    },
    '&:last-child': {
      borderRight: 0,
      padding: `0 ${theme.space.l}`,
    },
    columnGap: theme.space.m,
  }),
);

export const Header = () => {
  const { statusManagement } = useMedicationFollowupSettingStatus();
  const [{ latestMessageCreatedAt }, setState] = useAtom(patientPageInfoState);

  const handleChangeMessageSendAt = useCallback(
    (newDate: Date | null) => {
      setState((_state) => ({
        ..._state,
        latestMessageCreatedAt: newDate,
        page: 1,
      }));
    },
    [setState],
  );

  return (
    <ToolBar appearance="sort">
      <ToolBarItem>
        <SearchBox />
        <NewPatientButton />
      </ToolBarItem>
      <ToolBarItem>
        <InputDateWrapper>
          <SelectDateWithMoveButton
            value={latestMessageCreatedAt}
            onChange={handleChangeMessageSendAt}
            maxDate={new Date()}
            clearable
          />
        </InputDateWrapper>
      </ToolBarItem>
      {/* 本来はToolBarItemの中で条件分岐をするが下記のTODOの対応のため外側でくくる */}
      {statusManagement && (
        <ToolBarItem>
          <FollowingUpCheckBox />
          {/* TODO: 回答ありのフィルタリングが正しいロジックではないので、一度コメントアウトする
        https://medley-inc.slack.com/archives/C011YDCMYCA/p1689129117667229?thread_ts=1689064928.149529&cid=C011YDCMYCA
        <AnsweredCheckBox /> */}
        </ToolBarItem>
      )}
      <ToolBarItem>
        <SelectPharmacist />
      </ToolBarItem>
    </ToolBar>
  );
};
